import { Component, EventEmitter, OnInit, Output } from '@angular/core';

function getRandomNumberByRange(start, end) {
    return Math.round(Math.random() * (end - start) + start);
}

function createCanvas(width, height) {
    const canvas = createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
}

function createImg(onload) {
    const img = createElement('img');
    img.crossOrigin = 'Anonymous';
    img.onload = onload;
    img.onerror = () => {
        img.src = getRandomImg();
    };
    img.src = getRandomImg();
    return img;
}

function createElement(tagName) {
    return document.createElement(tagName);
}

function addClass(tag, className) {
    tag.classList.add(className);
}

function removeClass(tag, className) {
    tag.classList.remove(className);
}

function getRandomImg() {
    return 'https://picsum.photos/300/150/?image=' + getRandomNumberByRange(0, 100);
}

function sum(x, y) {
    return x + y;
}

function square(x) {
    return x * x;
}

@Component({
    selector: 'pz-verify',
    templateUrl: './verify.component.html',
    styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
    public sideWidth = 300;
    public sideHeight = 150;
    public sideRadius = 10;
    public sideLength = 42;
    public reallyLength: number;
    public canvas: any;
    public block: any;
    public sliderContainer: any;
    public refreshIcon: any;
    public slider: any;
    public sliderMask: any;
    public sliderIcon: any;
    public text: any;
    public canvasCtx: any;
    public blockCtx: any;
    public xPos: number;
    public yPos: number;
    public img: any;
    public root: any;
    public trail: any; // ç§»å¨è·ç¦»
    @Output()
    public submit: EventEmitter<boolean> = new EventEmitter<boolean>();

    public constructor() {
        //
    }

    public ngOnInit() {
        this.init();
    }

    public draw(ctx, operation, x, y) {
        const l = this.sideLength;
        const PI = Math.PI;
        const r = this.sideRadius;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x + l / 2, y);
        ctx.arc(x + l / 2, y - r + 2, r, 0, 2 * PI);
        ctx.lineTo(x + l / 2, y);
        ctx.lineTo(x + l, y);
        ctx.lineTo(x + l, y + l / 2);
        ctx.arc(x + l + r - 2, y + l / 2, r, 0, 2 * PI);
        ctx.lineTo(x + l, y + l / 2);
        ctx.lineTo(x + l, y + l);
        ctx.lineTo(x, y + l);
        ctx.lineTo(x, y);
        ctx.fillStyle = '#fff';
        ctx[operation]();
        ctx.beginPath();
        ctx.arc(x, y + l / 2, r, 1.5 * PI, 0.5 * PI);
        ctx.globalCompositeOperation = 'xor';
        ctx.fill();
    }

    public init() {
        this.reallyLength = this.sideLength + this.sideRadius * 2;
        this.root = document.getElementById('verify');
        this.initDOM();
        this.initImg();
        this.drawPic();
        this.bindEvents();
    }

    public initDOM() {
        const canvas = createCanvas(this.sideWidth, this.sideHeight); // ç»å¸
        const block = canvas.cloneNode(true); // æ»å
        const sliderContainer = createElement('div');
        const refreshIcon = createElement('div');
        const sliderMask = createElement('div');
        const slider = createElement('div');
        const sliderIcon = createElement('span');
        const text = createElement('span');

        block.className = 'block';
        sliderContainer.className = 'sliderContainer';
        refreshIcon.className = 'refreshIcon';
        refreshIcon.innerHTML = '<svg viewBox="64 64 896 896" fill="currentColor"\ ' +
            'width="1em" height="1em" data-icon="redo" aria-hidden="true">' +
            '<path d="M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5' +
            ' 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9' +
            ' 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4' +
            ' 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64' +
            ' 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1' +
            ' 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5' +
            ' 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5' +
            ' 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6' +
            ' 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1' +
            ' 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3' +
            ' 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7' +
            ' 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"></path>' +
            '</svg>';
        sliderMask.className = 'sliderMask';
        slider.className = 'slider';
        sliderIcon.className = 'sliderIcon';
        sliderIcon.innerHTML = '<svg viewBox="64 64 896 896" fill="currentColor" width="1em" ' +
            'height="1em" data-icon="arrow-right" aria-hidden="true"><path d="M869 487.8L491.2 ' +
            '159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 ' +
            '3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 ' +
            '5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"></path></svg>'
        text.innerHTML = '<svg viewBox="0 0 300 40">' +
            '  <linearGradient id="gr-radial"  x1="0%" y1="0%" x2="100%" y2="0%">' +
            '      <stop stop-color="#333" offset="0%"/>' +
            '      <stop stop-opacity="0.1" offset="50%">' +
            '          <animate attributeName="offset" from="0" to="1.3"' +
            '           dur="3s" repeatCount="indefinite" />' +
            '      </stop>' +
            '      <stop stop-color="#333" offset="100%"/>' +
            '  </linearGradient>' +
            '  <text text-anchor="middle" x="50%" y="50%" dy="5px"' +
            '  style="font-size:12pt; fill: url(#gr-radial)">åå³æ»å¨æ»åå¡«åæ¼å¾</text>' +
            '</svg>';
        text.className = 'sliderText';

        const el = this.root;
        el.appendChild(canvas);
        el.appendChild(refreshIcon);
        el.appendChild(block);
        slider.appendChild(sliderIcon);
        sliderMask.appendChild(slider);
        sliderContainer.appendChild(sliderMask);
        sliderContainer.appendChild(text);
        el.appendChild(sliderContainer);

        Object.assign(this, {
            canvas,
            block,
            sliderContainer,
            refreshIcon,
            slider,
            sliderMask,
            sliderIcon,
            text,
            canvasCtx: canvas.getContext('2d'),
            blockCtx: block.getContext('2d')
        });
    }

    public initImg() {
        const img = createImg(() => {
            this.canvasCtx.drawImage(img, 0, 0, this.sideWidth, this.sideHeight);
            this.blockCtx.drawImage(img, 0, 0, this.sideWidth, this.sideHeight);
            const y = this.yPos - this.sideRadius * 2 + 2;
            const imageData = this.blockCtx.getImageData(this.xPos, y, this.reallyLength, this.reallyLength);
            this.block.width = this.reallyLength;
            this.blockCtx.putImageData(imageData, 0, y);
        });
        this.img = img;
    }

    public drawPic() {
        // éæºåå»ºæ»åçä½ç½®
        this.xPos = getRandomNumberByRange(this.reallyLength + 10, this.sideWidth - (this.reallyLength + 10));
        this.yPos = getRandomNumberByRange(10 + this.sideRadius * 2, this.sideHeight - (this.reallyLength + 10));
        this.draw(this.canvasCtx, 'fill', this.xPos, this.yPos);
        this.draw(this.blockCtx, 'clip', this.xPos, this.yPos);
    }

    public clean() {
        this.canvasCtx.clearRect(0, 0, this.sideWidth, this.sideHeight);
        this.blockCtx.clearRect(0, 0, this.sideWidth, this.sideHeight);
        this.block.width = this.sideWidth;
    }

    public bindEvents() {
        this.root.onselectstart = () => false;
        this.refreshIcon.onclick = () => {
            this.reset();
        };

        let originX, originY, isMouseDown = false;
        const trail = [];
        this.slider.addEventListener('mousedown', function (e) {
            originX = e.x;
            originY = e.y;
            isMouseDown = true;
        });
        document.addEventListener('mousemove', (e) => {
            if (!isMouseDown) { return false; }
            const moveX = e.x - originX;
            const moveY = e.y - originY;
            if (moveX < 0 || moveX + 38 >= this.sideWidth) { return false; }
            this.slider.style.left = moveX + 'px';
            const blockLeft = (this.sideWidth - 40 - 20) / (this.sideWidth - 40) * moveX;
            this.block.style.left = blockLeft + 'px';
            if (moveX) {
                addClass(this.sliderContainer, 'sliderContainer_active');
            } else {
                removeClass(this.sliderContainer, 'sliderContainer_active');
            }
            this.sliderMask.style.width = ( moveX ? ( moveX + 15 ) : moveX ) + 'px';
            trail.push(moveY);
        });
        //
        document.addEventListener('mouseup', (e) => {
            if (!isMouseDown) { return false; }
            isMouseDown = false;
            if (e.x === originX) { return false; }
            removeClass(this.sliderContainer, 'sliderContainer_active');
            this.trail = trail;
            const {spliced, TuringTest} = this.verify();
            if (spliced) {
                if (TuringTest) {
                    addClass(this.sliderContainer, 'sliderContainer_success');
                    this.success();
                } else {
                    addClass(this.sliderContainer, 'sliderContainer_fail');
                    this.text.innerHTML = 'åè¯ä¸æ¬¡';
                    this.reset();
                }
            } else {
                if (e.x - originX > 0) {
                    addClass(this.sliderContainer, 'sliderContainer_fail');
                    this.fail();
                    setTimeout(() => {
                        this.reset();
                    }, 1000);
                }
            }
        });
    }

    public verify() {
        const arr = this.trail; // æå¨æ¶yè½´çç§»å¨è·ç¦»
        const average = arr.reduce(sum) / arr.length; // å¹³åå¼
        const deviations = arr.map(x => x - average); // åå·®æ°ç»
        const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length); // æ åå·®
        const left = parseInt(this.block.style.left);
        return {
            spliced: Math.abs(left - this.xPos ) < 10,
            TuringTest: average !== stddev, // åªæ¯ç®åçéªè¯æå¨è½¨è¿¹ï¼ç¸ç­æ¶ä¸è¬ä¸º0ï¼è¡¨ç¤ºå¯è½éäººä¸ºæä½
        };
    }

    public reset() {
        this.sliderContainer.className = 'sliderContainer';
        this.slider.style.left = 0;
        this.block.style.left = 0;
        this.sliderMask.style.width = 0;
        this.clean();
        this.img.src = getRandomImg();
        this.drawPic();
    }

    public success() {
        this.submit.emit(true);
        setTimeout(() => this.reset(), 1000);
    }
    public fail() {
        this.submit.emit(false);
    }
}
